import {useEffect} from 'react'
import Button from '@/components/form/Button'
import SharedButton from '@/components/shared/Button'
import logger from '@/lib/logger'
import buttonStyles from '@/styles/atoms/Button/styles.module.css'
import composesStyles from '@/styles/_settings/composes.module.css'
import labelStyles from '@/styles/atoms/Label/styles.module.css'

const Districts = ({state, districts, onChange, loggerAction}) => {
  useEffect(() => logger.action(loggerAction.onload), [])
  return (
    <div
      className={`${composesStyles.animation_enterfrombottom} ${composesStyles.paddingx} ${composesStyles.fullmaxwidth}`}
    >
      {state.profile && state.profile.city && (
        <>
          <div
            className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
          >
            <span className={labelStyles.ecLabel__value}>
              Em qual bairro/região você atua?
            </span>
            <div className={buttonStyles.ecButtonWrapper__ui}>
              <Button.Group
                strategy="multi"
                initialValue={state.districts || []}
                onChange={onChange}
              >
                {districts[state.profile.city].districts.map((item, index) => (
                  <SharedButton
                    key={index}
                    selected={state && state.districts.includes(item.uuid)}
                    small
                    value={item.uuid}
                  >
                    {item.name}
                  </SharedButton>
                ))}
              </Button.Group>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Districts
